import { createContext } from 'react'

/**
 * Lets a Present-mode slide temporarily suppress deck keyboard navigation
 * (Arrow keys / Esc) while it has a modal open — otherwise typing in the modal
 * would flip slides and Esc would exit the whole presentation. `PacketPresentBody`
 * provides the setter and guards its global key handler on the locked state.
 */
export const PresentNavLockContext = createContext<(locked: boolean) => void>(() => {})
